module.exports = __webpack_public_path__ + "img/animacao-logo-prisma.e47a18dc.gif";